import { observer } from 'mobx-react-lite';
import { PasswordField, SavingIndicator } from '../../../components';
import Webhooks from '../store/services/webhooks/Webhooks';
import Wix from '../store/services/webhooks/Wix';

export default observer(function WixForm({ webhooks }: { webhooks: Webhooks }) {
  const webhook = webhooks.selectedServices[0] as Wix;

  return (
    <>
      <PasswordField
        errorText={webhook.errors.webhookSecret}
        label="Webhook Secret"
        name="webhookSecret"
        onBlur={webhook.handleBlur}
        onChange={webhook.handleChange}
        required
        sx={{ width: '80%' }}
        value={webhook.webhookSecret}
      />

      <SavingIndicator indicator={webhook.indicator} sx={{ mt: 2 }} />
    </>
  );
});
